


























import { Vat } from '@/api';
import Toast from '@/components/display/toast.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { VatModals } from './models/vat-modals';
import SaveCancelButtons from '@/components/elements/buttons/save-cancel-buttons.vue';
import { VatService } from './service/vat-service';

@Component({
	components: { SaveCancelButtons },
})
export default class EditTempOffsetModal extends Vue {
	@Prop({ required: true, type: Object })
	public vat!: Vat;

	@Prop({ required: true, type: Boolean })
	public isFonterra!: Vat;

	public temperatureOffset: number = 0;
	public modalId: string = VatModals.TEMP_OFFSET;
	private toast = new Toast();
	private vatService: VatService = new VatService();
	public warningMessage: string = `Warning: ${this.vat.label ||
		'Vat'} offset temperature will be overridden by Fonterra`;

	public get checkLimits(): boolean {
		return this.temperatureOffset <= 2 && this.temperatureOffset >= -2;
	}

	public created() {
		this.temperatureOffset = this.vat.temperatureOffset ?? 0;
	}

	public async submit(): Promise<void> {
		if (this.checkLimits) {
			this.vat.temperatureOffset = this.temperatureOffset;
			const result = await this.saveTempOffset();
			if (result) {
				this.dismiss();
			}
		}
	}

	public async saveTempOffset(): Promise<boolean> {
		const res = await this.vatService.updateVatOffsetTemperature(
			this.vat.id,
			this.temperatureOffset,
		);
		if (res === undefined) {
			this.toast.makeToast(
				`${this.vat.label ?? 'Vat'} Offset Temperature`,
				'Offset Temperature updated successfully',
				'success',
			);
			return true;
		} else {
			this.toast.makeToast(
				'Error',
				'There was a problem updating the offset temperature',
				'danger',
				false,
			);
			return false;
		}
	}

	public dismiss(): void {
		this.$bvModal.hide(`${this.modalId}-${this.vat.id}`);
	}
}
